import { collapseClasses } from "@mui/material";
import React from "react";
import Alert from 'react-bootstrap/Alert';
//import classes from "../../Components/Home/home.module.scss";
import classes from "./error.module.scss";
import error_icon from "../../Resources/error/error_icon.png"; 
import { Icon } from '@genesis/ui-kit';


const Error = (props) => {
  return (
    <>
   
    <div className={classes.box} style={props.style}>
     <span className={classes.errorText}>
      <p className={classes.errorIcon}>
      <Icon name='errorOutlined' />
      </p><b>{props.message}</b>
     </span>
    </div>
  </>
  );
};

export default Error;
